import RibbonLeftSvg from 'assets/ver2/ribbons/ribbon-left.svg';
import RibbonRightSvg from 'assets/ver2/ribbons/ribbon-right.svg';
import React from 'react';
import styled from 'styled-components';
import { fontSize14Mixin, paragraph500Mixin } from 'styles';

const RIBBON_STEP_MAX = 1; // step initial: 0

const RIBBON_ACTIVE_COLOR = '#496ef1';
const RIBBON_UNACTIVE_COLOR = '#F6F6F6';
const RIBBON_PASSED_COLOR = '#f3f8ff';

const RibbonSteps = ({ currentStep, stepLabels = [] }) => {
  const getRibbonImgSrc = () => {
    if (currentStep === 0) return RibbonRightSvg;
    return RibbonLeftSvg;
  };
  const getRibbonImgStyles = () => {
    if (currentStep > 0) return { backgroundColor: RIBBON_ACTIVE_COLOR };
    return { backgroundColor: RIBBON_UNACTIVE_COLOR };
  };

  const getRibbonClassName = (step) => {
    if (currentStep === step) return 'ribbon-active';
    if (currentStep < RIBBON_STEP_MAX) return 'ribbon-unactive';
    return 'ribbon-passed';
  };

  return (
    <RibbonStepsStyled>
      <div className={getRibbonClassName(0)}>{stepLabels?.[0]}</div>
      <RibbonImg src={getRibbonImgSrc()} style={getRibbonImgStyles()} />
      <div className={getRibbonClassName(1)}>{stepLabels?.[1]}</div>
    </RibbonStepsStyled>
  );
};

const RibbonStepsStyled = styled.div`
  display: flex;
  border-radius: 100px;
  overflow: hidden;
  height: 30px;

  & div {
    ${paragraph500Mixin};
    ${fontSize14Mixin};
    padding-inline: 10px !important;
    width: 50%;
    display: flex;
    align-items: center;
  }

  & .ribbon-active {
    color: #fff;
    border-image: conic-gradient(${RIBBON_ACTIVE_COLOR} 0 0) fill 0;
    font-weight: 700;
  }

  & .ribbon-unactive {
    color: #7a8189;
    border-image: conic-gradient(${RIBBON_UNACTIVE_COLOR} 0 0) fill 0;
  }

  & .ribbon-passed {
    color: ${RIBBON_ACTIVE_COLOR};
    border-image: conic-gradient(${RIBBON_PASSED_COLOR} 0 0) fill 0;
    font-weight: 700;
  }
`;

const RibbonImg = styled.img`
  height: 30px;
  object-fit: contain;
`;

export default RibbonSteps;
